import { render, staticRenderFns } from "./SalerBusinessAuthority.vue?vue&type=template&id=6c9422b4&scoped=true&"
import script from "./SalerBusinessAuthority.vue?vue&type=script&lang=js&"
export * from "./SalerBusinessAuthority.vue?vue&type=script&lang=js&"
import style0 from "./SalerBusinessAuthority.vue?vue&type=style&index=0&id=6c9422b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9422b4",
  null
  
)

export default component.exports